import Dialog from '@/components/Dialog';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import { type ButtonProps } from '@mui/material';

type DialogLeaveButtonProps = Omit<ButtonProps, 'children'>;

const DialogLeaveButton = (props: DialogLeaveButtonProps) => (
  <Dialog.Actions.Button color="error" {...props}>
    <FormattedMessageWithChallengeNaming id="portfolio.challenge.sharing.leave.dialog_leave_button" />
  </Dialog.Actions.Button>
);

export default DialogLeaveButton;
